const TRANSIENT_CODES = new Set(["functions/aborted", "functions/unavailable", "functions/resource-exhausted"]);

/** Only use for operations whose payload is safe to replay unchanged. */
export async function retryCallable<T>(action: () => Promise<T>, options: {
  attempts?: number;
  onRetry?: (error: unknown, attempt: number) => void;
  sleep?: (milliseconds: number) => Promise<void>;
  random?: () => number;
} = {}): Promise<T> {
  const { attempts = 6, onRetry, sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms)), random = Math.random } = options;
  for (let attempt = 1; ; attempt += 1) {
    try { return await action(); }
    catch (error) {
      const code = error && typeof error === "object" && "code" in error ? String(error.code) : "";
      if (!TRANSIENT_CODES.has(code) || attempt >= attempts) throw error;
      onRetry?.(error, attempt);
      await sleep(Math.min(2000, 80 * 2 ** attempt) * (0.5 + random() * 0.5));
    }
  }
}
